(ns app.front.ui.tag-type-editor
  "E.g. attachment type editor"
  (:require [app.front.ui :as ui]
            [app.front.ui.add-widget :as ui-add]
            [app.front.ui.contextual-menu :as ctx-menu]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]))


(defn ->map [item]
  ;; no eu/->map because these don't need to be entities, i.e. :db/id may not be present
  ;; but still include :db/id if there
  (cond-> (select-keys item (keys item))
    (-> item :db/id some?) (assoc :db/id (:db/id item))))

(defn same-except-name [name-attr item edited-item]
  (= (-> item ->map (dissoc name-attr))
     (dissoc edited-item name-attr)))

(defn editor-for-single-tag [{:keys [*state
                                     editing?
                                     edited-item
                                     item
                                     tr
                                     selected?
                                     edit-disabled?
                                     toggle-disabled?
                                     on-toggle
                                     on-end-edit
                                     on-delete
                                     name-attr
                                     plain-strs?
                                     tag-type-name
                                     remove-confirmation
                                     deselect-confirmation
                                     additional-info-fn
                                     actions-fn]}]
  (r/with-let [*show-deselect-modal? (r/atom false)]
    (let [strs             (name-attr item)
          language         (when-not plain-strs?
                             (ui-i18n/get-actual-language-to-edit
                               strs
                               (<sub [::ui-i18n/editor-language ::gas/allowed-locales])))
          lang-text        (cond-> strs
                             (not plain-strs?) (get language))
          display-text     (or lang-text
                               (if plain-strs?
                                 (name-attr item)
                                 (-> item name-attr vals first)))
          toggle-id        (-> ((some-fn :db/id :id) item)
                               (or display-text)
                               (str "-toggle"))
          current-value    (cond-> (name-attr item)
                             (not plain-strs?) (get language))
          edited-value     (cond-> (name-attr edited-item)
                             (not plain-strs?) (get language))
          modified?        (and (-> edited-value str/blank? not)
                                (not= edited-value current-value))
          in-use?          (and edit-disabled?
                                (edit-disabled? item)
                                ;; allow editing when translation is missing
                                lang-text)
          toggle-disabled? (and toggle-disabled?
                                (toggle-disabled? item))
          editor-props     {:auto-focus  true
                            :input-class "-mt-6 -pl-2"
                            :on-blur     (fn [_]
                                           (swap! *state dissoc :edited-item)
                                           (when modified?
                                             (on-end-edit edited-item)))}
          on-change        #(swap! *state update :edited-item assoc name-attr %)
          deselect-msg     (if (fn? deselect-confirmation)
                             (deselect-confirmation item)
                             deselect-confirmation)]
      [:div.flex.avoid-break.items-center.w-full.justify-between.flex-wrap {:data-cy "attachment-type-row"}
       (when on-toggle
         [:<>
          [ui/confirm-modal
           {:open?        @*show-deselect-modal?
            :tr           tr
            :id           "toggle-off-modal"
            :modal-title  (tr [:are-you-sure])
            :on-yes-click (fn [] (on-toggle false item)
                            (reset! *show-deselect-modal? false))
            :on-close     #(reset! *show-deselect-modal? false)}
           deselect-msg]
          [:div.flex-initial.mr-2
           (cc/toggle {:toggled    (boolean (selected? item))
                       :id         toggle-id
                       :aria-label display-text
                       :disabled   toggle-disabled?
                       :labelA     ""
                       :labelB     ""
                       :class-name "unlabeled-toggle"
                       :on-toggle  (fn [enabled?]
                                     (if (and (not enabled?)
                                              deselect-msg)
                                       (reset! *show-deselect-modal? true)
                                       (on-toggle enabled? item)))})]])
       [:div.flex.justify-between.flex-1.items-center
        [:div
         (merge {:class ["p-2 pt-4 pr-3 edit-attachment-row my-2"
                         (when editing? "flex-1")
                         (when (and editing? (not in-use?) (nil? edited-item))
                           "bg-gray-200 rounded-md cursor-pointer")]}
                (when (and editing?
                           (not in-use?))
                  {:on-click #(swap! *state assoc :edited-item (->map item))
                   :data-cy  "start-edit"}))
         [:div.flex
          [:div.flex-1
           (if edited-item
             (if plain-strs?
               [ui/text-input
                (merge editor-props
                       {:value     (some name-attr [edited-item item])
                        :on-change (comp on-change futil/tval)})]
               [ui-i18n/localized-string-edit
                (merge editor-props
                       {:strings             (some name-attr [edited-item item])
                        :on-change           on-change
                        :allowed-locales-sub ::gas/allowed-locales})])
             [:div.pl-2.pt-1
              (when-not lang-text {:class "text-ui-red"})
              display-text])]
          (when (and editing?
                     (not in-use?))
            [:div.flex-initial
             (when-not edited-item
               (cc/icon {:icon        i/pen
                         :width       "15px"
                         :height      "15px"
                         :class-name  "attachment-edit-icon ml-2 mt-1"
                         :description ""}))])]]
        (when edited-item
          ;; the end edit -button
          [:div.flex-initial.py-2.pr-3
           (cc/icon {:icon        i/remove
                     :width       "15px"
                     :height      "15px"
                     :class-name  "ml-2 mt-1 cursor-pointer"
                     :description ""})])
        (when-let [content (and additional-info-fn (additional-info-fn item))]
          [:div.ml-4
           [ui/small-pill
            {:kind       :secondary
             :uppercase? false}
            content]])]
       (when editing?
         ;; the delete -button and actions menu
         [:div.flex-initial.p-2
          [ctx-menu/menu-or-button
           [{:actions (cond-> (if actions-fn (actions-fn item) (list))
                        (and on-delete
                             (not in-use?)) (conj {:title           (tr [:tag-type-editor/remove] [tag-type-name])
                                                   :data-cy         "remove-button"
                                                   :confirm?        true
                                                   :confirm-content [:span (or (if (fn? remove-confirmation)
                                                                                 (remove-confirmation item)
                                                                                 remove-confirmation)
                                                                               (tr [:tag-type-editor/remove-confirmation] [tag-type-name]))]
                                                   :on-click        (fn [_]
                                                                      (on-delete item)
                                                                      (when on-toggle
                                                                        (on-toggle false item)))
                                                   :icon            i/trash}))}]
           (util/mmap {:data-cy "additional-actions-menu"} tr)]])])))


(defn editor-toggles [{:keys [tr *state on-toggle-editor on-delete on-create on-end-edit tag-type-name has-values? plain-strs?]}]
  (let [{:keys [editing? adding?]} @*state]
    [:div.mb-2.flex.items-baseline
     [:div.flex-1
      (when-not plain-strs?
        [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}])]
     (when (and has-values?
                (or on-end-edit on-delete))
       (cc/button
         {:kind     :tertiary
          :size     :small
          :data-cy  "edit-toggle"
          :icon     (if editing? i/remove i/pen)
          :on-click #(do (swap! *state update :editing? not)
                         (when on-toggle-editor
                           (on-toggle-editor (not editing?))))}
         (tr [(if editing? :close :edit)])))
     (when on-create
       (cc/button
         {:kind       :primary
          :data-cy    "add-new-btn"
          :size       :small
          :icon       i/plus
          :class-name "ml-2"
          :disabled   (and has-values?
                           (or adding? editing?))
          :on-click   #(swap! *state assoc :adding? true)}
         (tr [:tag-type-editor/add-new] [tag-type-name])))]))

(defn type-list [{:keys [*state
                         tr
                         group-by-fn
                         values
                         selected?
                         edit-disabled?
                         toggle-disabled?
                         on-toggle
                         on-end-edit
                         on-delete
                         name-attr
                         plain-strs?
                         tag-type-name
                         remove-confirmation
                         deselect-confirmation
                         additional-info-fn
                         actions-fn]}]
  (let [{:keys [editing?
                edited-item]} @*state]
    [:div.tag-type-list
     (futil/for-all [[alpha items] (->> values
                                        (group-by (or group-by-fn (constantly nil)))
                                        (into (sorted-map)))]
       ^{:key (str "type-alpha-" alpha)}
       [:div.mb-4.clear
        (when group-by-fn
          [:h2.border-b-2.border-solid.border-ui-gray.text-gray-600.mb-1.avoid-break alpha])
        (futil/for-frag [item items]
          (let [editing-this? (same-except-name name-attr item edited-item)]
            [editor-for-single-tag (cond-> (util/mmap *state item tr selected? edit-disabled?
                                                      name-attr plain-strs?
                                                      editing?
                                                      tag-type-name remove-confirmation
                                                      deselect-confirmation
                                                      on-toggle on-end-edit on-delete
                                                      additional-info-fn actions-fn
                                                      toggle-disabled?)
                                     editing-this? (assoc :edited-item edited-item))]))])]))

(defn add-new-form [{:keys [tr on-create create-in-progress? on-cancel tag-type-name plain-strs?]}]
  (r/with-let [*value    (r/atom nil)
               on-change (partial reset! *value)]
    (let [editor-props {:light      true?
                        :label-text (str/capitalize (tr [:tag-type-editor/name] [tag-type-name]))
                        :auto-focus true}]
      [:div.mb-8
       [ui-add/add-widget
        {:title    (tr [:tag-type-editor/add-new] [tag-type-name])
         :loading? create-in-progress?
         :buttons  [{:text     (tr [:cancel])
                     :on-click on-cancel}
                    {:text      (tr [:save])
                     :disabled? (or (empty? @*value)
                                    create-in-progress?)
                     :on-click  #(on-create {(if plain-strs? :name :names) @*value
                                             :on-done                      on-cancel})}]}
        [:div.flex.flex-col.lg:flex-row
         (if plain-strs?
           [ui/text-input
            (merge editor-props
                   (util/mmap {:value     @*value
                               :on-change (comp on-change futil/tval)}))]
           [ui-i18n/localized-string-edit
            (merge editor-props
                   (util/mmap {:strings             @*value
                               :allowed-locales-sub ::gas/allowed-locales}
                              on-change))])]]])))

(defn- editor-skeleton []
  [:div.my-4
   [:div.mb-4.flex.justify-end
    (cc/button-skeleton {:small true})]
   [:div.mb-4.flex.items-center.gap-4
    [:div.w-12 (cc/skeleton-text {:width "100%"})]
    [:div.flex-1 (cc/skeleton-text {:width "100%"})]]
   [:div.mb-4.flex.items-center.gap-4
    [:div.w-12 (cc/skeleton-text {:width "100%"})]
    [:div.flex-1 (cc/skeleton-text {:width "75%"})]]
   [:div.flex.items-center.gap-4
    [:div.w-12 (cc/skeleton-text {:width "100%"})]
    [:div.flex-1 (cc/skeleton-text {:width "90%"})]]])

(defn editor
  "Editor that allows the user to select/unselect \"tags\" and create, delete or update the localizations of them.
  Disabling these functions can be done by not providing the on-toggle, on-create, on-delete and on-end-edit
  functions respectively.
  Editing specific values can be disabled with the edit-disabled? function.

  :values are maps of :id + :key and any other attrs needed by :name-attr, :group-by-fn etc
  :loading? replaces the editor controls and values with a skeleton

  :actions-fn is (fn [item] -> [ctx-menu/Action])
  :remove-confirmation and :deselect confirmation can be given to display a confirmation dialog for the
  respective operation. Both params may be a plain string or a function that receives the item operated on and
  returns the confirmation message."
  [{:keys [tr
           tag-type-name
           values
           selected?
           on-create
           on-toggle
           toggle-disabled?
           on-end-edit
           on-delete
           on-toggle-editor
           create-in-progress?
           loading?
           group-by-fn
           name-attr

           ;; use strings, not localized-strings
           plain-strs?
           edit-disabled?
           remove-confirmation
           deselect-confirmation
           additional-element
           additional-info-fn
           actions-fn]
    :or   {name-attr        :name
           edit-disabled?   (constantly false)
           toggle-disabled? (constantly false)}}]
  (r/with-let [*state (r/atom {:editing? false
                               :adding?  false})]
    (let [{:keys [adding?]} @*state
          has-values?       (-> values seq boolean)]
      (if loading?
        [editor-skeleton]
        [:div.my-4
         [editor-toggles (util/mmap tr *state on-toggle-editor on-end-edit on-create tag-type-name has-values? plain-strs?)]
         additional-element
         (when adding?
           [add-new-form (util/mmap {:on-cancel #(swap! *state assoc :adding? false)}
                                    tr *state on-create create-in-progress? tag-type-name plain-strs?)])
         [type-list (util/mmap tr *state group-by-fn name-attr plain-strs? values edit-disabled?
                               toggle-disabled?
                               tag-type-name remove-confirmation deselect-confirmation selected?
                               on-toggle on-end-edit on-delete
                               additional-info-fn actions-fn)]]))))
